import { render, staticRenderFns } from "./SupplierManufacturingQuility.vue?vue&type=template&id=c747e558&scoped=true&"
import script from "./SupplierManufacturingQuility.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingQuility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c747e558",
  null
  
)

export default component.exports